
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hMAfQ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $2O2Zk = parcelRequire("2O2Zk");


var $eNbr2 = parcelRequire("eNbr2");


var $794I6 = parcelRequire("794I6");


var $2DBsV = parcelRequire("2DBsV");


var $6OpMl = parcelRequire("6OpMl");


var $iDrrr = parcelRequire("iDrrr");


var $31fUM = parcelRequire("31fUM");

// eslint-disable-next-line @repo/internal/react/no-class-components -- class kept for WithProviders compatibility
class $1979132c998595a6$var$EmojiNode extends (0, $cozmU.PureComponent) {
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $794I6.WithProviders), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            providers: [
                'emojiProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        this.renderWithProvider = (providers)=>{
            const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, emojiProviderLookupOrder: emojiProviderLookupOrder, resourceConfig: resourceConfig } = this.props;
            if (allowTextFallback && !providers.emojiProvider) {
                // When the gate is enabled and the fallback text is not a single
                // standard Unicode emoji (i.e. this is a custom emoji whose fallback
                // is a `:shortname:`-style string), render the Unicode Replacement
                // Character (U+FFFD) instead of the shortName text. Standard emojis
                // continue to fall back to their Unicode text representation.
                const fallbackText = fallback || shortName;
                const useReplacementChar = (0, $iDrrr.fg)('platform_editor_custom_emoji_unicode_fallback') && !(0, $2DBsV.isSingleEmoji)(fallbackText);
                const renderedFallbackText = useReplacementChar ? '\uFFFD' : fallbackText;
                const accessibleLabel = `${(0, $2O2Zk.messages).emojiNodeLabel.defaultMessage} ${shortName}`;
                return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                    "aria-label": useReplacementChar ? accessibleLabel : undefined,
                    "data-emoji-id": id,
                    "data-emoji-short-name": shortName,
                    "data-emoji-text": renderedFallbackText,
                    role: useReplacementChar ? 'img' : undefined,
                    title: useReplacementChar ? shortName : undefined
                }, renderedFallbackText);
            }
            if (!providers.emojiProvider) return null;
            const customFallback = (0, $iDrrr.fg)('platform_editor_custom_emoji_unicode_fallback') && !(0, $2DBsV.isSingleEmoji)(fallback || shortName) ? '\uFFFD' : undefined;
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6OpMl.default), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                emojiId: {
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                },
                emojiProviderLookupOrder: emojiProviderLookupOrder,
                emojiProvider: providers.emojiProvider,
                showTooltip: showTooltip,
                fitToHeight: fitToHeight,
                optimistic: true,
                customFallback: customFallback,
                optimisticImageURL: resourceConfig?.optimisticImageApi?.getUrl({
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                }),
                editorEmoji: true,
                renderUnicodeEmojiAsImage: false,
                onEmojiLoadSuccess: resourceConfig?.onEmojiLoadSuccess,
                onEmojiLoadFail: resourceConfig?.onEmojiLoadFail
            });
        };
        this.providerFactory = props.providers || new (0, $eNbr2.default)();
    }
}
$1979132c998595a6$var$EmojiNode.displayName = 'EmojiNode';
$1979132c998595a6$var$EmojiNode.defaultProps = {
    showTooltip: true
};
const $1979132c998595a6$export$843daf88d968cb48 = (props)=>{
    const { id: id, providers: providers, shortName: shortName, text: text, fitToHeight: fitToHeight, emojiProviderLookupOrder: emojiProviderLookupOrder, resourceConfig: resourceConfig } = props;
    const inlineAnnotationProps = (0, $31fUM.useInlineAnnotationProps)(props);
    if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", inlineAnnotationProps, /*#__PURE__*/ (0, $lOiVq.jsx)($1979132c998595a6$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        emojiProviderLookupOrder: emojiProviderLookupOrder,
        resourceConfig: resourceConfig
    })));
    return /*#__PURE__*/ (0, $lOiVq.jsx)($1979132c998595a6$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        emojiProviderLookupOrder: emojiProviderLookupOrder,
        resourceConfig: resourceConfig
    });
};
const $1979132c998595a6$var$_default_1 = /*#__PURE__*/ (0, $cozmU.memo)($1979132c998595a6$export$843daf88d968cb48);
var $1979132c998595a6$export$2e2bcd8739ae039 = $1979132c998595a6$var$_default_1;
module.exports["default"] = $1979132c998595a6$export$2e2bcd8739ae039;

});

parcelRegister("31fUM", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc */ 
var $iDrrr = parcelRequire("iDrrr");


var $hZmcT = parcelRequire("hZmcT");

function $1e80a135c5761dad$export$11564cda945bb3c9(props) {
    const { selectionDraftDocumentPosition: draftPosition } = (0, $hZmcT.useAnnotationRangeState)();
    if (!(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
}
module.exports["useInlineAnnotationProps"] = $1e80a135c5761dad$export$11564cda945bb3c9;

});


//# sourceMappingURL=emoji.0d89fcd1.js.map
